// extracted by mini-css-extract-plugin
export default {"shares-section":"NftSharesSection_shares-section__S33jn","shares-icon":"NftSharesSection_shares-icon__OkOMc"};